import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** document with lines, note. Decorative line icon; always pair with a visible text label. */
export function NoteIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M6.5 3.5H14l4 4v13h-11.5z" />
      <path d="M14 3.5V8h4" />
      <path d="M9.5 12.5h5" />
      <path d="M9.5 16h5" />
    </IconSvg>
  )
}
